// FadeIn.js
import React from 'react';
import styled, { keyframes } from 'styled-components';
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

/**
 * FadeIn component.
 * Wraps children in a div that animates opacity from 0 to 1 on mount.
 * Animation duration and delay can be customized via props.
 * Animation is disabled if user prefers reduced motion.
 *
 * @param {Object} props
 * @param {number} [props.duration=300] - Animation duration in milliseconds.
 * @param {number} [props.delay=0] - Animation delay in milliseconds.
 * @param {React.ReactNode} props.children - Elements to animate.
 * @returns {JSX.Element}
 */
const FadeIn = ({
  duration = 300,
  delay = 0,
  children,
  ...delegated
}) => {
  return (
    <Wrapper
      {...delegated}
      style={{
        ...(delegated.style || {}),
        animationDuration: duration + 'ms',
        animationDelay: delay + 'ms',
      }}
    >
      {children}
    </Wrapper>
  );
};

/**
 * Styled wrapper div that applies the fade-in animation.
 */
const Wrapper = styled.div`
  @media (prefers-reduced-motion: no-preference) {
    animation-name: ${fadeIn};
    animation-fill-mode: backwards;
  }
`;
export default FadeIn;